/* Reserved mount point for the section 03 interactive component. Intentionally no artwork.
   Height approximates the Customer Operations system (~520px desktop) so surrounding rhythm stays stable. */
export default function SystemSlot({ name }: { name: string }) {
  return (
    <div
      data-system-slot={name}
      className="flex min-h-[240px] w-full flex-col items-center justify-center gap-2 bg-background-50 px-4 md:min-h-[520px]"
    >
      <span className="font-label text-[10px] uppercase tracking-[0.14em] text-foreground-500">Component slot / {name}</span>
      <span className="font-label text-[10px] uppercase tracking-[0.14em] text-foreground-400">Pending integration</span>
    </div>
  );
}